import React, { useState } from 'react';
import { KeyboardArrowLeft, KeyboardArrowDown } from '@material-ui/icons';
import { Container, Header, OpenButton } from './styles';
var CollapsableSection = function (_a) {
    var children = _a.children, header = _a.header, style = _a.style, _b = _a.defaultOpen, defaultOpen = _b === void 0 ? false : _b;
    var _c = useState(defaultOpen), isOpen = _c[0], setIsOpen = _c[1];
    var handleClick = function () {
        setIsOpen(function (previous) { return !previous; });
    };
    return (React.createElement(Container, { style: style },
        React.createElement(Header, null,
            header,
            React.createElement(OpenButton, { onClick: handleClick }, isOpen ? React.createElement(KeyboardArrowLeft, null) : React.createElement(KeyboardArrowDown, null))),
        isOpen && children));
};
export default CollapsableSection;
